import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getAlarmItemList = async (bsd_id, e_line, cur_page) => {
  const requestBody = {
    bsd_id,
    e_line,
    cur_page,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/selectAlarmItemList`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getStatusList = async (bsd_id, chnnl_no) => {
  const requestBody = {
    bsd_id,
    chnnl_no,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getSttusList`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertAlarmItem = async (data) => {
  const requestBody = {
    bsd_sttus_id: data.bsd_sttus_id,
    bsd_id: data.bsd_id,
    bsd_nm: data.bsd_nm,
    chnnl_no: data.chnnl_no,
    chnnl_nm: data.chnnl_nm,
    sms_ment: data.sms_ment,
    operator: data.operator,
    set_value: data.set_value,
    tx_period: data.tx_period,
    alarm_yn: data.alarm_yn,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/insAlarmItem`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updAlarmItem = async (data) => {
  const requestBody = {
    id: data.item_id,
    // bsd_sttus_id: data.bsd_sttus_id,
    // chnnl_no: data.chnnl_no,
    sms_ment: data.sms_ment != null ? data.sms_ment : '',
    operator: data.operator,
    set_value: data.set_value,
    tx_period: Number(data.tx_period),
    alarm_yn: data.alarm_yn,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/updAlarmItem`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const deleteAlarmItem = async (id, bsd_sttus_id) => {
  const requestBody = {
    id,
    bsd_sttus_id,
  };

  try {
    const response = await httpRequest(
      "post",
      `${URL}/delAlarmItem`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSmsItem = async (bsd_sttus_id) => {
  const requestBody = {
    bsd_sttus_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/selectCond`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSttusDef = async (bsd_sttus_id) => {
  const requestBody = {
    bsd_sttus_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getSttusDef`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getBsdSttusId = async (bsd_id, chnnl_no) => {
  const requestBody = {
    bsd_id,
    chnnl_no,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/getBsdSttusId`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
